<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="纹理褶皱"
      width="1320px"
      top="10px"
      @close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content" v-if="dialogVisible">
        <div class="solution-container">
          <div class="editor-section">
            <div :style="backgroundStyle" id="preview-container"></div>
            <div class="controls">
              <div class="control-group">
                <div class="group-title">🎨 褶皱参数</div>
                <div class="slider-container">
                  <div class="slider-label">
                    <span>褶皱深度</span>
                    <span>{{ depthValue.toFixed(1) }}</span>
                  </div>
                  <input
                    type="range"
                    id="depthSlider"
                    min="0.1"
                    max="1"
                    step="0.1"
                    :value="depthValue"
                    @input="updateDepth"
                  />
                </div>
                <div class="slider-container">
                  <div class="slider-label">
                    <span>褶皱偏移</span>
                    <span>{{ offsetValue.toFixed(1) }}</span>
                  </div>
                  <input
                    type="range"
                    id="offsetSlider"
                    min="0.1"
                    max="1"
                    step="0.1"
                    :value="offsetValue"
                    @input="updateOffset"
                  />
                </div>
                <div class="slider-container">
                  <div class="slider-label">
                    <span>阴影强度</span>
                    <span>{{ shadowValue.toFixed(1) }}</span>
                  </div>
                  <input
                    type="range"
                    id="shadowSlider"
                    min="0.1"
                    max="2"
                    step="0.1"
                    :value="shadowValue"
                    @input="updateShadow"
                  />
                </div>
                <el-button
                  style="
                    background: #409eff;
                    color: white;
                    border: 0;
                    width: 100%;
                    justify-content: center;
                    font-size: 1.1rem;
                    padding: 15px;
                    margin-top: 10px;
                  "
                  type="pri"
                  @click="sureTexture"
                  >确认褶皱效果</el-button
                >
                <el-button
                  style="
                    background: #ff6840;
                    color: white;
                    border: 0;
                    width: 100%;
                    justify-content: center;
                    font-size: 1.1rem;
                    padding: 15px;
                    margin-top: 10px;
                    margin-left: 0px;
                  "
                  type="pri"
                  @click="closeTexture"
                  >取消并关闭褶皱效果</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as THREE from "three";
export default {
  name: "Texture",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    modelUrl: {
      type: String,
      required: true,
    },
    baseTextureUrl: {
      type: String,
      required: true,
    },
    depth: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
    shadow: {
      type: Number,
      required: true,
    },
    maskUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      depthValue: 0.2,
      offsetValue: 0.0,
      shadowValue: 1.0,
      scene: null,
      camera: null,
      renderer: null,
      plane: null,
      displacementTexture: null,
      baseTexture: null,
      baseTexImage: null,
      shaderMaterial: null,
      animationFrameId: null,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.modelUrl})`,
      };
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    sureTexture() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        this.renderer.domElement.remove();
        this.renderer = null;
      }
      this.$emit("confirm", this.depthValue, this.offsetValue, this.shadowValue);
    },
    closeTexture() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        this.renderer.domElement.remove();
        this.renderer = null;
      }
      this.$emit("closeTexture");
    },
    init() {
      this.depthValue = this.depth ? this.depth : 0.2;
      this.offsetValue = this.offset ? this.offset : 0.0;
      this.shadowValue = this.shadow ? this.shadow : 1.0;
      const textureLoader = new THREE.TextureLoader();

      textureLoader.load(this.baseTextureUrl, (baseTex) => {
        const imgWidth = baseTex.image.width;
        const imgHeight = baseTex.image.height;
        this.baseTexImage = baseTex.image;
        const aspectRatio = imgWidth / imgHeight;
        const planeWidth = 6 * aspectRatio;
        const planeHeight = 6;

        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(75, aspectRatio, 0.1, 1000);
        const fov = this.camera.fov * (Math.PI / 180);
        const distance = planeHeight / 2 / Math.tan(fov / 2);
        this.camera.position.z = distance;

        this.renderer = new THREE.WebGLRenderer({
          alpha: true,
          antialias: true,
          preserveDrawingBuffer: true,
        });
        this.renderer.setSize(imgWidth, imgHeight);
        this.renderer.setClearColor(0x000000, 0);
        document
          .getElementById("preview-container")
          .appendChild(this.renderer.domElement);
        if(this.maskUrl){
          this.renderer.domElement.style.maskImage = `url(${this.maskUrl})`
          this.renderer.domElement.style.maskSize = "100% 100%"
        }
        baseTex.colorSpace = THREE.NoColorSpace;
        this.baseTexture = baseTex;

        textureLoader.load(this.modelUrl, (modelTex) => {
          modelTex.colorSpace = THREE.NoColorSpace;
          this.convertToGrayScale(this.modelUrl, (grayCanvas) => {
            this.displacementTexture = new THREE.CanvasTexture(grayCanvas);
            this.displacementTexture.colorSpace = THREE.NoColorSpace;

            this.createShaderMaterial(
              this.baseTexture,
              this.displacementTexture
            );

            const geometry = new THREE.PlaneGeometry(
              planeWidth,
              planeHeight,
              512,
              512
            );
            this.plane = new THREE.Mesh(geometry, this.shaderMaterial);
            this.scene.add(this.plane);

            this.animate();
          });
        });
      });
    },

    animate() {
      this.animationFrameId = requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
    },

    createShaderMaterial(baseTex, displacementTex) {
      this.shaderMaterial = new THREE.ShaderMaterial({
        uniforms: {
            map: { value: baseTex },
            displacementMap: { value: displacementTex },
            displacementScale: { value: this.depthValue },
            opacity: { value: 1.0 },
            offset: { value: this.offsetValue },
            lightIntensity: { value: 1.0 },
            lightHeight: { value: 45.0 },
            shadowIntensity: { value:  this.shadowValue }
        },
        vertexShader: `
          uniform sampler2D displacementMap;
          uniform float displacementScale;
          uniform float offset;
          varying vec2 vUv;
          varying vec3 vPosition;
          
          void main() {
              vUv = uv;
              vec4 disp = texture2D(displacementMap, uv);
              float displacement = (disp.r - offset) * displacementScale;
              vec3 newPosition = position + normal * displacement;
              gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
              vPosition = newPosition;
          }
        `,
        fragmentShader: `
            uniform sampler2D map;
            uniform sampler2D displacementMap;
            uniform float opacity;
            uniform float lightIntensity;
            uniform float lightHeight;
            uniform float shadowIntensity;
            varying vec2 vUv;
            varying vec3 vPosition;
            
            // 计算法线向量（基于高度图）
            vec3 calculateNormal(vec2 uv) {
                // 获取当前像素和相邻像素的高度值
                float center = texture2D(displacementMap, uv).r;
                float right = texture2D(displacementMap, uv + vec2(0.001, 0.0)).r;
                float top = texture2D(displacementMap, uv + vec2(0.0, 0.001)).r;
                
                // 计算梯度（高度变化率）
                float dx = (right - center) * shadowIntensity * 10.0;
                float dy = (top - center) * shadowIntensity * 10.0;
                // 从梯度构造法线向量
                return normalize(vec3(-dx, -dy, 1.0));
            }
            
            // Phong光照模型
            vec3 phongLighting(vec3 normal, vec3 lightDir, vec3 viewDir, vec3 color) {
                // 环境光
                float ambient = 0.3;
                
                // 漫反射
                float diff = max(dot(normal, lightDir), 0.0);
                
                // 镜面反射
                vec3 reflectDir = reflect(-lightDir, normal);
                float spec = pow(max(dot(viewDir, reflectDir), 0.0), 32.0);
                float specular = spec * 0.5;
                
                // 组合光照
                return color * (ambient + diff * lightIntensity + specular);
            }
          void main() {
            vec4 texColor = texture2D(map, vUv);
            
            // 计算法线（基于位移贴图）
            vec3 normal = calculateNormal(vUv);
            
            // 计算光照方向（基于光源高度）
            float rad = radians(lightHeight);
            vec3 lightDir = normalize(vec3(sin(rad), 0.0, cos(rad)));
            
            // 计算视线方向
            vec3 viewDir = normalize(-vPosition);
            
            // 应用Phong光照模型
            vec3 litColor = phongLighting(normal, lightDir, viewDir, texColor.rgb);
            
            // 确保正确输出颜色和透明度
            gl_FragColor = vec4(litColor, texColor.a * opacity);
          }
        `,
        transparent: true,
        depthTest: true,
        depthWrite: true,
      });
    },

    convertToGrayScale(imageUrl, callback) {
      const image = new Image();
      image.crossOrigin = "Anonymous";
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const canvas2 = document.createElement("canvas");
        const ctx2 = canvas2.getContext("2d");
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
        canvas2.width = this.baseTexImage.width;
        canvas2.height = this.baseTexImage.height;
        ctx2.drawImage(this.baseTexImage, 0, 0);

        const imageData2 = ctx2.getImageData(
          0,
          0,
          canvas2.width,
          canvas2.height
        );
        const data = imageData.data;
        const data2 = imageData2.data;
        let min = 255,
          max = 0;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          const gray = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          const enhanced = Math.pow(gray / 255, 1.5) * 255;
          data[i] = data[i + 1] = data[i + 2] = enhanced;
        }

        this.applyGaussianBlurToData(imageData, 8);
        if (!this.offset) {
          const imageDataf = ctx.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );
          const dataf = imageDataf.data;

          for (let i = 0; i < dataf.length; i += 4) {
            const alpha = data2[i + 3];
            if (alpha === 0) continue;
            const r = dataf[i];
            const g = dataf[i + 1];
            const b = dataf[i + 2];
            const gray = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            const enhanced = Math.pow(gray / 255, 1.5) * 255;
            if (enhanced > max) max = enhanced;
            if (enhanced < min) min = enhanced;
          }

          const midValue = ((max + min) / 2 / 255).toFixed(1);
          this.offsetValue = parseFloat(midValue);
        }
        ctx.putImageData(imageData, 0, 0);
        callback(canvas);
      };
      image.src = imageUrl;
    },

    applyGaussianBlurToData(imageData, radius) {
      const data = imageData.data;
      const width = imageData.width;
      const height = imageData.height;
      const tempData = new Uint8ClampedArray(data.length);

      // 水平模糊
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          let r = 0,
            g = 0,
            b = 0,
            count = 0;

          for (let dx = -radius; dx <= radius; dx++) {
            const nx = x + dx;
            if (nx >= 0 && nx < width) {
              const idx = (y * width + nx) * 4;
              r += data[idx];
              g += data[idx + 1];
              b += data[idx + 2];
              count++;
            }
          }

          const idx = (y * width + x) * 4;
          tempData[idx] = r / count;
          tempData[idx + 1] = g / count;
          tempData[idx + 2] = b / count;
          tempData[idx + 3] = data[idx + 3];
        }
      }

      // 垂直模糊
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          let r = 0,
            g = 0,
            b = 0,
            count = 0;

          for (let dy = -radius; dy <= radius; dy++) {
            const ny = y + dy;
            if (ny >= 0 && ny < height) {
              const idx = (ny * width + x) * 4;
              r += tempData[idx];
              g += tempData[idx + 1];
              b += tempData[idx + 2];
              count++;
            }
          }

          const idx = (y * width + x) * 4;
          data[idx] = r / count;
          data[idx + 1] = g / count;
          data[idx + 2] = b / count;
        }
      }
    },

    updateDepth(e) {
      this.depthValue = parseFloat(e.target.value);
      if (this.shaderMaterial) {
        this.shaderMaterial.uniforms.displacementScale.value = this.depthValue;
      }
    },

    updateOffset(e) {
      this.offsetValue = parseFloat(e.target.value);
      if (this.shaderMaterial) {
        this.shaderMaterial.uniforms.offset.value = this.offsetValue;
      }
    },

    updateShadow(e) {
      this.shadowValue = parseFloat(e.target.value);
      if (this.shaderMaterial) {
        this.shaderMaterial.uniforms.shadowIntensity.value = this.shadowValue;
      }
    },

    closeDialog() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        this.renderer.domElement.remove();
        this.renderer = null;
      }
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}

body {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: #e6e6e6;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  overflow-x: hidden;
}

.app-container {
  max-width: 1200px;
  width: 100%;
}

header {
  text-align: center;
  margin: 20px 0 40px;
  width: 100%;
  padding: 20px;
}

h1 {
  font-size: 2.8rem;
  margin-bottom: 15px;
  background: linear-gradient(45deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.85;
  margin-bottom: 20px;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.demo-controls {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.demo-btn {
  padding: 12px 25px;
  border-radius: 8px;
  background: rgba(30, 30, 60, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ff7e5f;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.demo-btn:hover {
  background: rgba(50, 50, 90, 0.9);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.component-info {
  background: rgba(30, 30, 60, 0.6);
  border-radius: 15px;
  padding: 25px;
  margin: 30px 0;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.info-icon {
  font-size: 2.5rem;
  color: #feb47b;
}

.info-title {
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(45deg, #feb47b, #ff7e5f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.code-block {
  background: #0d1117;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  overflow-x: auto;
  font-family: "Courier New", monospace;
  font-size: 0.95rem;
  line-height: 1.6;
}

.code-comment {
  color: #8b949e;
}

.code-tag {
  color: #7ee787;
}

.code-attr {
  color: #79c0ff;
}

.code-string {
  color: #a5d6ff;
}

.code-keyword {
  color: #ff7b72;
}

.solution-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
}

.editor-section {
  padding: 25px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  backdrop-filter: blur(10px);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

#preview-container {
  width: max-content;
  height: max-content;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.control-group {
  padding: 20px;
  width: 400px;
}

.group-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
  font-size: 1.2rem;
  color: #feb47b;
}

.slider-container {
  margin-bottom: 15px;
}

.slider-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  /* color: white; */
  font-size: 0.95rem;
}

input[type="range"] {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: rgba(100, 100, 150, 0.3);
  outline: none;
  -webkit-appearance: none;
}

input[type="range"]:hover {
  background: rgba(120, 120, 180, 0.4);
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff7e5f;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(255, 126, 95, 0.5);
  transition: all 0.2s ease;
}

input[type="range"]::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  background: #ff9e85;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn {
  flex: 1;
  min-width: 150px;
  padding: 14px 20px;
  border-radius: 10px;
  border: none;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.btn-primary {
  background: linear-gradient(45deg, #ff7e5f, #feb47b);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 126, 95, 0.4);
}

.btn-secondary {
  background: rgba(50, 100, 200, 0.25);
  color: #a0c0ff;
  border: 1px solid rgba(100, 150, 255, 0.3);
}

.btn-secondary:hover {
  background: rgba(60, 120, 220, 0.35);
  transform: translateY(-3px);
}

::v-deep .el-dialog {
  border-radius: 15px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5) !important;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #EDEDED;
  padding: 20px;
}

::v-deep .el-dialog__title {
  color: #feb47b !important;
  font-size: 1.4rem;
  font-weight: 600;
}

::v-deep .el-dialog__body {
  padding: 0 20px 20px !important;
}

::v-deep .el-dialog__headerbtn {
  top: 22px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #ff7e5f !important;
  font-size: 1.4rem;
}

::v-deep .dialog-content {
  padding: 0 15px;
}

footer {
  margin-top: 40px;
  text-align: center;
  font-size: 0.9rem;
  opacity: 0.7;
  width: 100%;
  padding: 20px;
}

@media (max-width: 900px) {
  .solution-container {
    flex-direction: column;
    align-items: center;
  }

  h1 {
    font-size: 2.3rem;
  }

  .el-dialog {
    width: 95% !important;
  }
}
</style>